import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { QrCode, CheckCircle2, XCircle } from "lucide-react";

// Landing page for the emailed UPI-change confirm link: /confirm-upi?token=…
// One click applies the staged payout-UPI change.
export default function ConfirmUpi() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("working"); // working | done | error
  const [upi, setUpi] = useState(null);
  const [err, setErr] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;      // guard React 18 StrictMode double-invoke (token is single-use)
    ran.current = true;
    if (!token) { setState("error"); setErr("Missing confirmation token."); return; }
    api.post("/auth/confirm-upi", { token })
      .then((r) => { setUpi(r.data); setState("done"); })
      .catch((e) => { setErr(e.response?.data?.detail || "Confirmation failed"); setState("error"); });
  }, [token]);

  return (
    <div className="min-h-screen qd-admin grid place-items-center p-6">
      <div className="w-full max-w-sm bg-white rounded-2xl p-8 border border-gray-200 shadow-sm text-center">
        <div className="w-10 h-10 rounded-lg bg-[var(--qd-charcoal)] grid place-items-center mb-6 mx-auto"><QrCode className="w-4 h-4 text-white" aria-hidden /></div>
        {state === "working" && <p className="text-sm text-gray-500">Confirming your UPI change…</p>}
        {state === "done" && (
          <>
            <CheckCircle2 className="w-10 h-10 text-green-600 mx-auto mb-3" aria-hidden />
            <h1 className="font-display text-2xl font-bold tracking-tight">UPI confirmed</h1>
            <p className="text-sm text-gray-500 mt-2">Online payments now go to <b>{upi?.upi_id}</b>{upi?.upi_name ? ` (${upi.upi_name})` : ""}.</p>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="w-10 h-10 text-red-500 mx-auto mb-3" aria-hidden />
            <h1 className="font-display text-2xl font-bold tracking-tight">Link not valid</h1>
            <p className="text-sm text-gray-500 mt-2">{err} Request the change again from Settings.</p>
          </>
        )}
        <Link to="/admin/settings" className="inline-block mt-6 text-sm font-semibold text-[var(--qd-primary)]">Go to Settings →</Link>
      </div>
    </div>
  );
}
